import React from 'react'
import "./A2Why.css"
import A2WhyHead from './A2WhyHead'
import A2WhyMain from './A2WhyMain'

const A2Why = () => {
  return (
    <div className='a2WhyContainer'>
      <A2WhyHead/>
      <A2WhyMain/>
    </div>
  )
}

export default A2Why
